// Import model
import { PhoneFieldOptions } from '../models/PhoneFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PhoneFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class PhoneFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a PhoneFieldOptions instance
   */
  static deserialize(json: string): PhoneFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PhoneFieldOptions instance
   */
  static fromObject(obj: any): PhoneFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PhoneFieldOptions');
    }


    const instance: PhoneFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      autoFormat: obj['AutoFormat'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PhoneFieldOptions instances
   */
  static deserializeArray(json: string): PhoneFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PhoneFieldOptions instance to a JSON string
   */
  static serialize(instance: PhoneFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PhoneFieldOptions instance to a plain object
   */
  static toObject(instance: PhoneFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'AutoFormat': instance.autoFormat,
    };
  }

  /**
   * Serializes an array of PhoneFieldOptions instances to a JSON string
   */
  static serializeArray(instances: PhoneFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
